<template>
    <div class="unrecommendable-reason">
        <StackRouterHeaderBar />

        <main class="main">
            <FeedbackTop
                :title="`${user.name || user.nickname || user.profile.nickname}님을<br>왜 추천하지 않나요?`"
                :description="'선택한 내용은 상대방에게 공개되지 않아요'"
            />

            <ul class="feedback-option-items" v-if="sincerityReasons.length > 0 || mannerReasons.length > 0">
                <p class="multi-select m-b-20">*복수 선택 가능</p>
                <p class="option-title m-b-12">진정성이 없어요</p>
                <li v-for="(item, idx) in sincerityReasons" :key="item.id">
                    <p
                        v-html="item.title"
                        class="item"
                        :class="{ selected: item.selected }"
                        @click="onClickSincerityReason(idx)"
                    />

                    <transition name="slide-down">
                        <div
                            v-if="
                                showDetailSincerityReason &&
                                item.title === '기타' &&
                                item.category === 'sincerity_reason'
                            "
                            class="detail-reason m-b-12"
                        >
                            <p class="desc m-b-8">직접 입력해주세요</p>
                            <TextareaWithX :placeholder="'내용을 입력해주세요'" v-model="detailSincerityReason" />
                        </div>
                    </transition>
                </li>
                <p class="option-title m-t-40 m-b-12">매너가 없어요</p>
                <li v-for="(item, idx) in mannerReasons" :key="item.id">
                    <p
                        v-html="item.title"
                        class="item"
                        :class="{ selected: item.selected }"
                        @click="onClickMannerReason(idx)"
                    />
                    <transition name="slide-down">
                        <div
                            v-if="showDetailMannerReason && item.title === '기타' && item.category === 'manner_reason'"
                            class="detail-reason m-b-12"
                        >
                            <p class="desc m-b-8">직접 입력해주세요</p>
                            <TextareaWithX :placeholder="'내용을 입력해주세요'" v-model="detailMannerReason" />
                        </div>
                    </transition>
                </li>
            </ul>
        </main>

        <footer class="footer">
            <button class="btn btn-primary" v-html="$translate('SUBMIT')" :disabled="disabled" @click="onClickSubmit" />
        </footer>
    </div>
</template>

<script>
import FeedbackTop from './components/FeedbackTopComponent'
import datingService from '@/services/dating'

export default {
    name: 'UnrecommendableReasonPage',
    components: { FeedbackTop },
    props: {
        user: Object,
    },
    data: () => ({
        detailSincerityReason: '',
        detailMannerReason: '',
        sincerityReasons: [],
        mannerReasons: [],
        multiSelect: true,
    }),
    computed: {
        disabled() {
            return (
                this.sincerityReasons.filter(item => item.selected).length === 0 &&
                this.mannerReasons.filter(item => item.selected).length === 0
            )
        },
        showDetailSincerityReason() {
            const etc = this.sincerityReasons.find(item => item.title === '기타')
            if (!etc) return

            return etc.selected
        },
        showDetailMannerReason() {
            const etc = this.mannerReasons.find(item => item.title === '기타')
            if (!etc) return

            return etc.selected
        },
    },
    methods: {
        async init() {
            const sincerityOptions = await this.$store.dispatch('filterFeedbackOptionByCategory', `sincerity_reason`)
            const mannerOptions = await this.$store.dispatch('filterFeedbackOptionByCategory', `manner_reason`)

            this.sincerityReasons = sincerityOptions.map(option => {
                this.$set(option, 'selected', false)
                return option
            })

            this.mannerReasons = mannerOptions.map(option => {
                this.$set(option, 'selected', false)
                return option
            })
        },
        async onClickSubmit() {
            const sincerityPayload = this.preparedSincerityPayload()
            const mannerPayload = this.preparedMannerPayload()
            this.$store.commit('setSelectedFeedbacks', {
                category: 'unrecommendSincerityReason',
                feedbacks: sincerityPayload,
            })
            this.$store.commit('setSelectedFeedbacks', {
                category: 'unrecommendMannerReason',
                feedbacks: mannerPayload,
            })
            try {
                this.$loading(true)
                const { payload, dating } = await this.$store.dispatch('prepareFeedbackPayload')
                await datingService.feedback(dating.id, payload)
                await this.$store.dispatch('loadDatingSuccess')

                this.$toast.success('THANKS_TO_SUBMIT')
            } catch (e) {
                this.$toast.error(e.data)
            } finally {
                this.$loading(false)
                this.$stackRouter.clear()
            }
        },
        preparedSincerityPayload() {
            return this.sincerityReasons
                .filter(item => item.selected)
                .map(item => {
                    if (item.title === '기타') {
                        return { id: item.id, detail: this.detailSincerityReason }
                    } else {
                        return { id: item.id }
                    }
                })
        },
        preparedMannerPayload() {
            return this.mannerReasons
                .filter(item => item.selected)
                .map(item => {
                    if (item.title === '기타') {
                        return { id: item.id, detail: this.detailMannerReason }
                    } else {
                        return { id: item.id }
                    }
                })
        },
        onClickSincerityReason(idx) {
            if (!this.multiSelect) {
                this.sincerityReasons.forEach(item => {
                    item.selected = false
                })
                this.$set(this.sincerityReasons[idx], 'selected', !this.sincerityReasons[idx].selected)
            } else {
                this.$set(this.sincerityReasons[idx], 'selected', !this.sincerityReasons[idx].selected)
            }
        },
        onClickMannerReason(idx) {
            if (!this.multiSelect) {
                this.mannerReasons.forEach(item => {
                    item.selected = false
                })
                this.$set(this.mannerReasons[idx], 'selected', !this.mannerReasons[idx].selected)
            } else {
                this.$set(this.mannerReasons[idx], 'selected', !this.mannerReasons[idx].selected)
            }
        },
    },
    mounted() {
        this.init()
    },
}
</script>

<style lang="scss" scoped>
.unrecommendable-reason {
    .main {
        height: calc(100% - 56px - 80px);
        overflow-y: auto;
        padding: 0 16px;

        .feedback-option-items {
            margin-bottom: 24px;

            .multi-select {
                font-size: 12px;
                color: $grey-07;
            }

            .option-title {
                font-size: 15px;
                color: black;
                @include f-medium;
            }

            li {
                .item {
                    padding: 11px 16px;
                    border-radius: 8px;
                    border: solid 1px $grey-02;
                    font-size: 15px;
                    color: $grey-08;
                    min-height: 44px;

                    // &:not(:last-child) {
                    margin-bottom: 8px;
                    // }

                    &.selected {
                        border-color: $purple-primary;
                        color: black;
                    }
                }
            }
        }
    }

    .items {
        margin-bottom: 24px;

        .item {
            padding: 11px 16px;
            border-radius: 8px;
            border: solid 1px $grey-02;

            &:not(:last-child) {
                margin-bottom: 8px;
            }
        }
    }

    .detail-reason {
        .desc {
            font-size: 12px;
            color: $grey-06;
            font-weight: 500;

            @include f-medium;
        }

        .textarea-with-x {
            height: 160px;
        }
    }

    .footer {
        position: absolute;
        bottom: 0;
        padding: 16px 20px;
        width: 100vw;
        border-top: solid 1px $grey-02;

        .btn {
            width: 100%;
            height: 48px;
        }
    }
}
</style>
